import MissingPolicyMethodException from "@/utils/Exceptions/Policies/MissingPolicyMethodException";

export default class BossPolicy {
    static perform(method, user, model) {
        if (typeof this[method] !== "function") {
            throw new MissingPolicyMethodException('Missing policy method ' + method + ' in ' + model.constructor.name);
        }

        return this[method](user, model);
    }
}
